import { useCallback } from "react";
import { showErrorToast } from "../../assets/toastUtils";
import DaySelectionWeekDays from "./DaySelectionWeekDays";
import DateRangePicker from "./DateRangePicker/DateRangePicker";
import { SvgPlusCircle } from "../../utils/svgIcons";

const InventoryMultipleDatesRangesAndWeekDays = ({ dateRanges = [], setDateRanges, propertyCurrentDate }) => {

  const handleAddRange = () => {
    const lastRange = dateRanges[dateRanges.length - 1];

    // Validate current range
    if (!lastRange.dates.from_date || !lastRange.dates.to_date) {
      showErrorToast(
        "Please select both start and end dates for the current range"
      );
      return;
    }

    if (Object.keys(lastRange.days).length === 0) {
      showErrorToast("Please select at least one day for the current range");
      return;
    }

    // Check for duplicate date ranges with same days
    const existingRanges = dateRanges.slice(0, -1);
    const isDuplicate = existingRanges.some((range) => {
      // Check if dates match
      const sameDates =
        range.dates.from_date === lastRange.dates.from_date &&
        range.dates.to_date === lastRange.dates.to_date;

      // Check if days selection is identical
      const sameDays =
        JSON.stringify(range.days) === JSON.stringify(lastRange.days);

      return sameDates && sameDays;
    });

    if (isDuplicate) {
      showErrorToast(
        "This date range with the same days selection already exists"
      );
      return;
    }

    // Add new empty range
    setDateRanges((prev) => [
      ...prev,
      {
        id: Date.now(),
        dates: { from_date: "", to_date: "" },
        days: {},
      },
    ]);
  };

  const handleRemoveRange = (id) => {
    if (dateRanges.length > 1) {
      setDateRanges((prev) => prev.filter((range) => range.id !== id));
    }
  };

  const handleDateChange = (id, from_date, to_date) => {
    setDateRanges((prev) =>
      prev.map((range) =>
        range.id === id ? { ...range, dates: { from_date, to_date } } : range
      )
    );
  };

  const handleDaysChange = useCallback((id, data) => {
    setDateRanges((prev) =>
      prev.map((range) => (range.id === id ? { ...range, days: data } : range))
    );
  }, []);

  return (
    <div>
      {dateRanges.map((range, index) => (
        <div
          key={range.id}
          className="mb-10"
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <div style={{ width: "100%" }}>
            <DateRangePicker
              defaultDate={{
                startDate: range?.dates?.from_date,
                endDate: range?.dates?.to_date,
              }}
              size={"medium"}
              onChange={(from_date, to_date) =>
                handleDateChange(range.id, from_date, to_date)
              }
              disabled={index === dateRanges.length - 1 ? false : true}
              minDate={new Date(propertyCurrentDate)}
            />
          </div>
          <hr style={{margin: '10px 0'}} />
          <div className="flex justify_content_between align_items_end">
            <DaySelectionWeekDays
              onSaveDates={(data) => handleDaysChange(range?.id, data)}
              disabled={index === dateRanges.length - 1 ? false : true}
            />

            <div className="flex justify_content_end flex_gap_10 align_items_center">
              {dateRanges.length === index + 1 && (
                <span onClick={handleAddRange} className="pointer">
                  <SvgPlusCircle />
                </span>
              )}
              {dateRanges.length > 1 && (
                <span
                  onClick={() => handleRemoveRange(range?.id)}
                  className="pointer"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.2001 3.2H13.6001C14.0419 3.2 14.4001 3.55817 14.4001 4L14.4001 4.8H1.6001L1.60012 4C1.60012 3.55817 1.95829 3.2 2.40012 3.2H4.80012V1.2C4.80012 0.537258 5.33738 0 6.00012 0H10.0001C10.6629 0 11.2001 0.537259 11.2001 1.2V3.2ZM6.40012 1.6V3.2H9.60012V1.6H6.40012Z"
                      fill={"#E03838"}
                    ></path>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.40012 6.4H13.6001V14.8C13.6001 15.4627 13.0629 16 12.4001 16H3.60012C2.93738 16 2.40012 15.4627 2.40012 14.8V6.4ZM5.6001 8.8H4.0001V13.6H5.6001V8.8ZM8.8001 8.8H7.2001V13.6H8.8001V8.8ZM10.4001 8.8H12.0001V13.6H10.4001V8.8Z"
                      fill={"#E03838"}
                    ></path>
                  </svg>
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InventoryMultipleDatesRangesAndWeekDays;
